import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 1,
  class: "main-content"
}
const _hoisted_3 = {
  key: 2,
  id: "app-loading"
}

import { onMounted, computed } from 'vue';
import { useStore } from './services/store.service';
import { useAuthService } from './services/auth.service';
import { setTitle } from './services/title.service';
import { useDeviceService } from './services/device.service';
import AppNavigation from './components/AppNavigation.vue';
import AppNotifications from './components/AppNotifications.vue';
import { useNotifications } from './services/notifications.service';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

setTitle();
useDeviceService();
const store = useStore();
const authService = useAuthService();
const { showError } = useNotifications();

const isLoading = computed(() => !store.isAppReady());

onMounted(async () => {
  store.setAppReady(false);

  const configSuccess = await authService.config();
  if (!configSuccess) {
    console.error('Application Failed. Please try again later.');
    showError('Application Failed. Please try again later.', 99999);
    return;
  }

  await authService.user();
  store.setAppReady(true);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppNotifications),
    (!isLoading.value)
      ? (_openBlock(), _createBlock(AppNavigation, { key: 0 }))
      : _createCommentVNode("", true),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("main", _hoisted_2, [
          _createVNode(_component_router_view)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "spinner" }, null, -1),
          _createElementVNode("div", { class: "loading-text" }, "Loading...", -1)
        ])))
  ]))
}
}

})